<div class="row">
  <div class="col">
    <div class="page-nav-header no-pills">
      <div class="d-flex align-items-center justify-content-between w-100">
        <div class="back-container align-items-center">
          <button type="button" class="btn btn-transparent p-0" (click)="goBack()" aria-label="back">
            <fa-icon icon="arrow-left" class="circle-icon-btn" aria-hidden="true"></fa-icon>
            <span class="sr-only">back</span>
          </button>
          <div class="d-flex align-items-center">
            <fui-heading [text]="isEdit ? community.title || community.string_id || 'Community' : 'New Community'" [level]="5"></fui-heading>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    @if (!hasAccess) {
      <div class="alert alert-warning m-t-20">
        You don't have community-admin authority on this community. Ask a global admin to add you to one of this community's
        <strong>admin_roles</strong>
        MySQL groups.
      </div>
    }

    @if (hasAccess) {
      <div class="d-flex">
        <myp-segmented-bar
          [white]="true"
          [options]="[
            { name: 'General', id: 'general', selected: selectedSection === 'general' },
            { name: 'Channels', id: 'channels', selected: selectedSection === 'channels', disabled: !isEdit },
          ]"
          (selected)="switchSection($event?.id)"
        ></myp-segmented-bar>
        @if (selectedSection === "channels") {
          <button class="fa-button m-l-10" placement="bottom" [ngbTooltip]="'Add Channel'" (click)="addEditChannel()">
            <fa-icon icon="plus" class="action create-action circle-icon-btn"></fa-icon>
          </button>
        }
      </div>

      @if (loading) {
        <myp-inline-loader [loading]="true" height="200px" spinnerName="communityDetailLoader"></myp-inline-loader>
      }

      @if (!loading && selectedSection === "general") {
        <div class="m-t-20">
          <div class="row">
            <div class="form-group col-md-6">
              <label class="control-label" for="community-title">Title</label>
              <input type="text" name="title" id="community-title" [(ngModel)]="community.title" class="form-control" />
            </div>
            <div class="form-group col-md-6">
              <label class="control-label" for="community-string-id">String ID (kebab-case, cannot change once created)</label>
              <input type="text" name="string_id" id="community-string-id" [disabled]="isEdit" [(ngModel)]="community.string_id" class="form-control" placeholder="tone-master-pro" />
            </div>

            <div class="form-group col-md-12">
              <label class="control-label" for="community-description-en">Description</label>
              <textarea
                name="description_en"
                id="community-description-en"
                [(ngModel)]="descriptions.en"
                class="form-control"
                rows="2"
                placeholder="Short blurb shown under the community title in the header."
              ></textarea>
              <div class="d-flex align-items-center m-t-5">
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="autoTranslateDescription()" [disabled]="translatingDescription || !descriptions.en?.trim()">
                  {{ translatingDescription ? "Translating…" : "Auto-translate" }}
                </button>
                @if (descriptionOtherLocales.length) {
                  <button type="button" class="btn btn-sm btn-link" (click)="showDescriptionLocales = !showDescriptionLocales">
                    {{ showDescriptionLocales ? "Hide" : "Show" }} translations ({{ descriptionOtherLocales.length }})
                  </button>
                }
              </div>
              @if (showDescriptionLocales) {
                <div class="m-t-10">
                  @for (locale of descriptionOtherLocales; track locale) {
                    <div class="form-group">
                      <label class="control-label small text-uppercase text-muted" [attr.for]="'community-description-' + locale">{{ locale }}</label>
                      <textarea [name]="'description_' + locale" [id]="'community-description-' + locale" [(ngModel)]="descriptions[locale]" class="form-control" rows="2"></textarea>
                    </div>
                  }
                </div>
              }
            </div>

            <div class="form-group col-md-6">
              <label class="control-label" for="community-participation">Participation condition</label>
              <select class="form-control" name="participation_condition" id="community-participation" [(ngModel)]="community.participation_condition">
                <option value="none">Anyone signed in</option>
                <option value="fsp_plus_subscriber">Fender Studio Pro+ Subscriber</option>
                <option value="fender_play_subscriber">Fender Play Subscriber</option>
                <option value="product_owner">Product Owner</option>
                <option value="group_member">Group Member</option>
              </select>
              <small class="text-muted">Communities are always publicly viewable. This gates who can post.</small>
            </div>
            <div class="form-group col-md-6">
              <label class="control-label" for="community-order">Order</label>
              <input type="number" name="order" id="community-order" [(ngModel)]="community.order" class="form-control" />
            </div>

            @if (community.participation_condition === "group_member") {
              <div class="form-group col-md-12">
                <label class="control-label" for="required-groups-input">Required groups</label>
                <div
                  id="required-groups-input"
                  class="form-control"
                  [class.pointer]="!groupsLoading"
                  [attr.tabindex]="groupsLoading ? -1 : 0"
                  [attr.role]="groupsLoading ? null : 'button'"
                  [attr.aria-busy]="groupsLoading"
                  (click)="openGroupPicker('required')"
                  (keyup.enter)="openGroupPicker('required')"
                  (keydown.space)="openGroupPicker('required'); $event.preventDefault()"
                >
                  @if (groupsLoading) {
                    <span class="text-muted">
                      <fa-icon icon="spinner" [animation]="'spin'" class="m-r-5"></fa-icon>
                      Loading…
                    </span>
                  } @else if (requiredGroupsDisplay) {
                    {{ requiredGroupsDisplay }}
                  } @else {
                    <span class="text-muted">Choose…</span>
                  }
                </div>
                <small class="text-muted">User must be in at least one of the selected MySQL groups to post. Enforcement lands with the follow-up in the plan doc.</small>
              </div>
            }

            @if (community.participation_condition === "product_owner") {
              <div class="form-group col-md-12">
                <label class="control-label">Required products</label>
                <div class="d-flex m-b-10">
                  <span class="radio-option" (click)="setProductInputMode('name')" [class.selected]="productInputMode === 'name'">
                    @if (productInputMode === "name") {
                      <fa-icon icon="check-circle"></fa-icon>
                    }
                    Search by name
                  </span>
                  <span class="radio-option" (click)="setProductInputMode('sku')" [class.selected]="productInputMode === 'sku'">
                    @if (productInputMode === "sku") {
                      <fa-icon icon="check-circle"></fa-icon>
                    }
                    Enter SKU
                  </span>
                  <span class="radio-option" (click)="setProductInputMode('productNo')" [class.selected]="productInputMode === 'productNo'">
                    @if (productInputMode === "productNo") {
                      <fa-icon icon="check-circle"></fa-icon>
                    }
                    Enter product number
                  </span>
                  <span class="radio-option" (click)="setProductInputMode('string_id')" [class.selected]="productInputMode === 'string_id'">
                    @if (productInputMode === "string_id") {
                      <fa-icon icon="check-circle"></fa-icon>
                    }
                    Enter string ID
                  </span>
                </div>

                <div class="secondary-content-bg p-x-10 p-y-10 border-radius20">
                  @if (productInputMode === "name") {
                    <div class="d-flex m-b-10 t-13">
                      <span class="radio-option" (click)="setProductSearchCatalog('fender')" [class.selected]="productSearchCatalog === 'fender'">
                        @if (productSearchCatalog === "fender") {
                          <fa-icon icon="check-circle"></fa-icon>
                        }
                        Instruments, Pedals and Amps
                      </span>
                      <span class="radio-option" (click)="setProductSearchCatalog('presonus')" [class.selected]="productSearchCatalog === 'presonus'">
                        @if (productSearchCatalog === "presonus") {
                          <fa-icon icon="check-circle"></fa-icon>
                        }
                        Recording Hardware and Software
                      </span>
                    </div>
                  }

                  <input
                    type="text"
                    id="community-required-products-search"
                    name="required_products_search"
                    [ngModel]="productQuery"
                    (ngModelChange)="onProductQueryInput($event)"
                    class="form-control"
                    [placeholder]="
                      productInputMode === 'name'
                        ? productSearchCatalog === 'fender'
                          ? 'Search instruments, pedals and amps by name…'
                          : 'Search recording hardware and software by name…'
                        : productInputMode === 'sku'
                          ? 'Enter SKU to look up…'
                          : productInputMode === 'productNo'
                            ? 'Enter product number to look up…'
                            : 'Enter string ID to look up…'
                    "
                    autocomplete="off"
                  />
                </div>
                <small class="text-muted">User must own at least one of the selected products to post.</small>

                @if (productSearching) {
                  <div class="d-flex align-items-center m-t-10 text-muted">
                    <fa-icon icon="spinner" [animation]="'spin'" class="m-r-5"></fa-icon>
                    Searching…
                  </div>
                }

                @if (productResults.length) {
                  <div class="product-results m-t-10 trans-bg border-radius10 p-10">
                    @for (result of productResults; track result.requirement.value) {
                      <myp-list-item
                        [title]="result.requirement.label || result.requirement.value"
                        [subData]="[result.requirement.type + ': ' + result.requirement.value]"
                        [includeChevron]="false"
                        [imageRound]="false"
                        [showImage]="!!result.requirement.image"
                        [photo]="result.requirement.image"
                      >
                        <div class="button-content">
                          <fa-icon icon="plus" placement="left" [ngbTooltip]="'Add Product'" (click)="addRequiredProduct(result.requirement)" class="action green circle-icon-btn m-r-10"></fa-icon>
                        </div>
                      </myp-list-item>
                    }
                  </div>
                }

                @if (productQuery && !productSearching && !productResults.length) {
                  <div class="m-t-10 text-muted">No matches.</div>
                }

                @if (requiredProducts.length) {
                  <div class="m-t-15">
                    @for (item of requiredProducts; track item.type + ":" + item.value) {
                      <myp-list-item
                        [showImage]="!!item.image"
                        [photo]="item.image"
                        [showBackground]="true"
                        marginBottom="5px"
                        [imageRound]="false"
                        [title]="item.label || item.value"
                        [subData]="[item.type + ': ' + item.value]"
                        [includeChevron]="false"
                      >
                        <div class="button-content">
                          <fa-icon icon="times" placement="left" [ngbTooltip]="'Remove Product'" (click)="removeRequiredProduct(item)" class="action circle-icon-btn"></fa-icon>
                        </div>
                      </myp-list-item>
                    }
                  </div>
                }
              </div>
            }
          </div>

          <hr />
          <h4 class="section-header m-t-10 m-b-10">
            <fui-heading [text]="'Roles'" [level]="5"></fui-heading>
          </h4>
          <div class="m-b-10 text-muted">
            Users in the selected MySQL groups get community-moderator / community-admin permissions on this community. Groups must already exist — create them in the Groups admin first if needed.
          </div>

          <div class="row">
            <div class="form-group col-md-6">
              <label class="control-label" for="mod-roles-input">Moderator Roles</label>
              <div
                id="mod-roles-input"
                class="form-control"
                [class.pointer]="!groupsLoading"
                [attr.tabindex]="groupsLoading ? -1 : 0"
                [attr.role]="groupsLoading ? null : 'button'"
                [attr.aria-busy]="groupsLoading"
                (click)="openGroupPicker('moderator')"
                (keyup.enter)="openGroupPicker('moderator')"
                (keydown.space)="openGroupPicker('moderator'); $event.preventDefault()"
              >
                @if (groupsLoading) {
                  <span class="text-muted">
                    <fa-icon icon="spinner" [animation]="'spin'" class="m-r-5"></fa-icon>
                    Loading…
                  </span>
                } @else if (moderatorRolesDisplay) {
                  {{ moderatorRolesDisplay }}
                } @else {
                  <span class="text-muted">Choose…</span>
                }
              </div>
            </div>

            <div class="form-group col-md-6">
              <label class="control-label" for="admin-roles-input">Admin Roles</label>
              <div
                id="admin-roles-input"
                class="form-control"
                [class.pointer]="!groupsLoading"
                [attr.tabindex]="groupsLoading ? -1 : 0"
                [attr.role]="groupsLoading ? null : 'button'"
                [attr.aria-busy]="groupsLoading"
                (click)="openGroupPicker('admin')"
                (keyup.enter)="openGroupPicker('admin')"
                (keydown.space)="openGroupPicker('admin'); $event.preventDefault()"
              >
                @if (groupsLoading) {
                  <span class="text-muted">
                    <fa-icon icon="spinner" [animation]="'spin'" class="m-r-5"></fa-icon>
                    Loading…
                  </span>
                } @else if (adminRolesDisplay) {
                  {{ adminRolesDisplay }}
                } @else {
                  <span class="text-muted">Choose…</span>
                }
              </div>
            </div>
          </div>

          <hr />
          <h4 class="section-header m-t-10 m-b-10">
            <fui-heading [text]="'Features'" [level]="5"></fui-heading>
          </h4>
          <div class="row">
            <div class="form-group col-md-6">
              <label class="control-label" for="community-editor">Editor</label>
              <select class="form-control" name="editor" id="community-editor" [(ngModel)]="features.editor">
                <option value="contenteditable">Content-editable (public community default)</option>
                <option value="quill">Quill (rich text)</option>
              </select>
            </div>
            <div class="form-group col-md-6">
              <label class="control-label">View Modes</label>
              <div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" id="viewmode-list" [checked]="features.view_modes.includes('list')" (change)="toggleViewMode('list')" />
                  <label class="form-check-label" for="viewmode-list">List</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" id="viewmode-detailed" [checked]="features.view_modes.includes('detailed')" (change)="toggleViewMode('detailed')" />
                  <label class="form-check-label" for="viewmode-detailed">Detailed</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <!--
                Feature toggles stacked as a single column of `myp-switch`es. Hidden lives
                here (rather than in the top identity row) because it's the same kind of
                per-community boolean setting. Each `(toggle)` flips the bound value —
                `myp-switch` emits without echoing the new value, so we mutate directly.
              -->
              <myp-switch class="d-block m-b-10" [active]="!!community.hidden" [label]="'Hidden'" [labelToRight]="true" (toggle)="community.hidden = !community.hidden"></myp-switch>
              <!-- Employees only: everyone else doesn't see the community at all — for trying one in
                   prod with staff first. Pairs with `features.communitiesHubForEmployees`. -->
              <myp-switch
                class="d-block m-b-10"
                [active]="!!community.employee_only"
                [label]="'Employees only'"
                [labelToRight]="true"
                (toggle)="community.employee_only = !community.employee_only"
              ></myp-switch>
              <!--
                Which paeapi environments serve the community. The Firestore collection is
                shared by every environment, so this is how a new community is tried in dev or
                QA without appearing in prod. Unlike Hidden it is enforced: a direct link 404s
                where the community isn't served.
              -->
              <div class="form-group m-b-15">
                <label class="control-label d-block">Available in</label>
                @for (env of environmentOptions; track env.id) {
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" [id]="'community-env-' + env.id" [checked]="environmentMap[env.id]" (change)="environmentMap[env.id] = !environmentMap[env.id]" />
                    <label class="form-check-label" [for]="'community-env-' + env.id">{{ env.label }}</label>
                  </div>
                }
                <small class="form-text text-muted d-block">Untick Prod to try a community in dev or QA first. Admins see it here in every environment.</small>
              </div>
              <myp-switch
                class="d-block m-b-10"
                [active]="!!features.subject_required"
                [label]="'Subject required'"
                [labelToRight]="true"
                (toggle)="features.subject_required = !features.subject_required"
              ></myp-switch>
              <myp-switch
                class="d-block m-b-10"
                [active]="!!features.mentions_enabled"
                [label]="'Mentions enabled'"
                [labelToRight]="true"
                (toggle)="features.mentions_enabled = !features.mentions_enabled"
              ></myp-switch>
              <myp-switch
                class="d-block m-b-10"
                [active]="!!features.scheduled_posts"
                [label]="'Scheduled posts'"
                [labelToRight]="true"
                (toggle)="features.scheduled_posts = !features.scheduled_posts"
              ></myp-switch>
              <myp-switch
                class="d-block m-b-10"
                [active]="!!features.announcements"
                [label]="'Announcements'"
                [labelToRight]="true"
                (toggle)="features.announcements = !features.announcements"
              ></myp-switch>
            </div>
          </div>

          <hr />
          <h4 class="section-header m-t-10 m-b-10">
            <fui-heading [text]="'Extras & branding'" [level]="5"></fui-heading>
          </h4>
          <div class="row">
            @for (slot of brandingImageSlots; track slot) {
              <ng-container *ngTemplateOutlet="brandingImage; context: { $implicit: brandingImages[slot], slot: slot }"></ng-container>
            }
            <div class="form-group col-md-6">
              <label class="control-label" for="community-hero-theme">Hero theme</label>
              <select name="hero_theme" id="community-hero-theme" [(ngModel)]="branding.hero_theme" class="form-control">
                <option [ngValue]="null">Inherit viewer's theme</option>
                <option value="light">Light (dark text)</option>
                <option value="dark">Dark (light text)</option>
              </select>
              <small class="text-muted">
                Which theme drives the hero section's text and borders. Pick "Dark" if your image is dark and needs light text, "Light" if it's light and needs dark text. The rest of the page still
                follows the viewer's chosen theme.
              </small>
            </div>
            <div class="form-group col-md-6">
              <label class="control-label" for="community-accent-color">Accent color (hex)</label>
              <input type="text" name="accent_color" id="community-accent-color" [(ngModel)]="branding.accent_color" class="form-control" placeholder="#ff0000" />
            </div>
            <div class="form-group col-12">
              <label class="control-label" for="community-welcome-html">Welcome HTML (rendered as plain text in header today)</label>
              <textarea name="welcome_html" id="community-welcome-html" [(ngModel)]="branding.welcome_html" class="form-control" rows="3"></textarea>
            </div>
            <div class="form-group col-12">
              <label class="control-label" for="community-empty-state-html">Empty state HTML</label>
              <textarea name="empty_state_html" id="community-empty-state-html" [(ngModel)]="branding.empty_state_html" class="form-control" rows="3"></textarea>
            </div>
          </div>

          <div class="d-flex justify-content-end m-y-30">
            <button class="btn btn-primary" [disabled]="loading || !hasAccess" (click)="submit()">
              @if (loading) {
                <fa-icon icon="spinner" animation="spin" class="m-r-10"></fa-icon>
              }
              {{ loading ? "Saving..." : isEdit ? "Save" : "Create" }}
            </button>
          </div>
        </div>
      }

      @if (!loading && selectedSection === "channels") {
        <div class="m-t-20">
          @if (channelsLoading) {
            <myp-inline-loader [loading]="true" height="200px" spinnerName="communityChannelsLoader"></myp-inline-loader>
          }
          @if (!channelsLoading && !channels.length) {
            <span class="t-16 d-block m-t-30 gothic text-center">No channels yet. Add one to get started.</span>
          }
          @if (channels.length) {
            @for (channel of channels; track channel.string_id) {
              <myp-list-item
                [title]="(channel.title | localize: channel.string_id) || channel.string_id"
                [showImage]="false"
                [subData]="[
                  channel.string_id,
                  (channel.description | localize: '') || '(no description)',
                  channel.is_public ? 'Public' : 'Restricted',
                  channel.is_alphabetical ? 'Alphabetical' : 'Ordered',
                  channel.posting_groups?.length ? 'Posts: ' + channel.posting_groups.join(', ') : 'Anyone can post',
                  isChannelFullyTranslated(channel) ? '✓ Fully translated' : '⚠ Missing translations',
                ]"
                [item]="channel"
                (itemClicked)="addEditChannel(channel)"
              >
                <div class="button-content">
                  @if (!isChannelFullyTranslated(channel)) {
                    <button class="fa-button" (click)="autoTranslateChannel(channel, $event)" [disabled]="translatingChannel[channel.string_id]">
                      <fa-icon
                        [icon]="translatingChannel[channel.string_id] ? 'spinner' : 'language'"
                        [animation]="translatingChannel[channel.string_id] ? spinAnimation : undefined"
                        placement="top"
                        [ngbTooltip]="translatingChannel[channel.string_id] ? 'Translating…' : 'Auto-translate + save'"
                        class="action circle-icon-btn m-r-5"
                      ></fa-icon>
                      <span class="sr-only">Auto-translate Channel</span>
                    </button>
                  }
                  <button class="fa-button">
                    <fa-icon icon="edit" placement="top" [ngbTooltip]="'Edit'" class="action circle-icon-btn m-r-5"></fa-icon>
                    <span class="sr-only">Edit Channel</span>
                  </button>
                  <button class="fa-button" (click)="deleteChannel(channel, $event)">
                    <fa-icon icon="times" placement="top" [ngbTooltip]="'Archive'" class="action circle-icon-btn m-r-5"></fa-icon>
                    <span class="sr-only">Archive Channel</span>
                  </button>
                </div>
              </myp-list-item>
            }
          }

          <!--
        Announcements: Phase A (deferred — see MULTI-COMMUNITY-EXPANSION-PLAN §Phase 4
        follow-ups). Community announcements are just posts with `pinned: true` — moderators
        pin from the post's menu inside `<myp-community>`, no separate admin composer needed.
        Leaving no UI here on purpose so admins aren't tempted to look for a form that
        doesn't exist.
      -->
        </div>
      }
    }
  </div>
</div>

<!-- One branding image slot (hero, icon): drop zone, then the current file with Remove. -->
<ng-template #brandingImage let-img let-slot="slot">
  <div class="form-group col-md-6">
    <label class="control-label">{{ img.label }}</label>
    @if ((!img.uploader || !img.uploader.queue.length) && !branding[img.field]) {
      <div ng2FileDrop class="content-bg content-drop-zone m-b-20" [class.hovering]="img.hovering" (fileOver)="fileOverBrandingImage(slot, $event)" [uploader]="img.uploader">
        <div>{{ img.hint }}</div>
      </div>
    }
    @if (img.selectedFile || branding[img.field]) {
      <div class="content-bg m-b-20 d-flex align-items-center">
        <img
          [src]="img.display || branding[img.field]"
          [style.width.px]="40"
          [style.height.px]="slot === 'icon' ? 40 : null"
          [style.object-fit]="slot === 'icon' ? 'cover' : null"
          [style.border-radius.px]="slot === 'icon' ? 8 : null"
          style="margin-right: 10px"
        />
        @if (img.progress) {
          <div class="d-flex m-x-10 align-items-center">
            <fa-icon icon="spinner" [animation]="'spin'" class="m-r-5"></fa-icon>
            <strong>{{ img.progress }}%</strong>
          </div>
        }
        <div class="d-flex justify-content-between align-items-center w-full">
          <div class="text-truncate overflow-hidden">
            <span class="brandfont-black">{{ img.fileName }}</span>
          </div>
          <button type="button" class="btn btn-sm btn-secondary" (click)="removeBrandingImage(slot)">Remove</button>
        </div>
      </div>
    }
  </div>
</ng-template>
